import { atom } from "jotai";

export const analyticsHelpersIds = atom({
  smartlook_code: "",
  snapchat_code: "",
  facebook_code: "",
  google_analytics_id: "",
  google_tag: "",
  x_pixel_id: "",
});
